import {
  fetchUsersAction,
  fetchControllerAction,
  fetchUserControllerAction,
  updateOtaAction,
  addControllerAction,
  updateControllerAction,
  fetchInvoiceAction,
  factoryResetAction,
} from "./actions";

const fetchUsers = (dispatch) => () => dispatch(fetchUsersAction());
const fetchController = (dispatch) => () => dispatch(fetchControllerAction());
const fetchUserController = (dispatch) => () =>
  dispatch(fetchUserControllerAction());

const updateOta = (dispatch) => (payload) => dispatch(updateOtaAction(payload));
const addController = (dispatch) => (payload) =>
  dispatch(addControllerAction(payload));

const updateController = (dispatch) => (payload) =>
  dispatch(updateControllerAction(payload));

const fetchInvoice = (dispatch) => () => dispatch(fetchInvoiceAction());
const factoryReset = (dispatch) => (payload) =>
  dispatch(factoryResetAction(payload));

const operations = {
  fetchUsers,
  fetchController,
  fetchUserController,
  updateOta,
  addController,
  updateController,
  fetchInvoice,
  factoryReset,
};
export default operations;
